import type { Variant } from "../types";

export function isVariantAvailable(variant?: Variant) {
  if (!variant) return false;
  if (typeof variant.availableForSale === "boolean") return variant.availableForSale;
  return Number(variant.quantityAvailable) > 0;
}

export function variantMaximum(variant?: Variant): string | null {
  if (!isVariantAvailable(variant)) return "0";
  if (variant?.currentlyNotInStock || variant?.quantityAvailable === null) return null;
  return variant?.quantityAvailable || "0";
}
